import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {UserService} from "../../services/user.service";
import {FormBuilder, FormsModule} from "@angular/forms";
import {Tab, TabList, Tabs} from "primeng/tabs";
import {filter, map} from "rxjs";
import {ActivatedRoute, NavigationEnd, Router, RouterLink, RouterOutlet} from "@angular/router";
import {toSignal} from "@angular/core/rxjs-interop";
import {environment} from "../../environments/environment";

@Component({
  selector: 'app-dashboard-page',
  standalone: true,
  imports: [
    Tabs,
    TabList,
    Tab,
    RouterLink,
    RouterOutlet,
    FormsModule,
  ],
  templateUrl: './dashboard-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardPageComponent {
  protected readonly users$ = this.userService.users$.pipe(
    map(users => users.sort((a,b) => new Date(a.createdAt) > new Date(b.createdAt) ? 1 : -1))
  );

  protected readonly route = inject(ActivatedRoute);
  protected readonly router = inject(Router);

  // Singal of initial segment of the route
  protected readonly initialSegment$ = this.router.events.pipe(filter(e => e instanceof NavigationEnd), map(
    event => event.url.split('/').filter(segment => segment.length > 0)[0] ?? 'users'
    )
  )

  protected readonly initialSegment = toSignal(
    this.initialSegment$,
    {initialValue: 'users'}
  );

  protected readonly manualCheckEnabled = environment.allowManualNotificationCheck === true;

  constructor(private readonly userService: UserService, private fb: FormBuilder) {
  }
}
